module.exports = __webpack_public_path__ + "img/liqpay.facfcfe8.svg";